"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractFlattenedCalendarEvents = void 0;
function extractFlattenedCalendarEvents(calendarEventResults) {
    return calendarEventResults
        .map(result => result.value)
        .flat();
}
exports.extractFlattenedCalendarEvents = extractFlattenedCalendarEvents;
